<template>
  <BaseLayout title="Course Materials">
    <div class="container my-4">
      <h1 class="display-4 text-center">Course Materials</h1>
      <p class="text-center text-muted">Documents your teachers have shared for this semester.</p>

      <div v-if="loading" class="text-center my-4">
        <div class="spinner-border" role="status">
          <span class="sr-only">&nbsp;&nbsp;Loading...</span>
        </div>
      </div>
      <div v-else>
        <div v-if="courseDocuments.length === 0" class="alert alert-info text-center">
          No course materials available yet.
          <button @click="fetchDocuments" class="btn btn-primary">
            <i class="bi bi-arrow-clockwise me-2"></i>Refresh
          </button>
        </div>
        <div v-else class="card">
          <div class="card-header">Available Materials</div>
          <ul class="list-group list-group-flush">
            <li v-for="doc in courseDocuments" :key="doc.id" class="list-group-item">
              <div class="d-flex justify-content-between align-items-start flex-wrap">
                <div class="me-3">
                  <span class="badge bg-secondary me-2 text-uppercase">{{ doc.fileType || 'file' }}</span>
                  <strong>{{ doc.file_name }}</strong>
                  <div class="small text-muted mt-1">
                    {{ formatFileSize(doc.file_size) }} · Added {{ formatDate(doc.created_at) }}
                  </div>
                </div>
                <div class="btn-group btn-group-sm mt-1" role="group">
                  <button class="btn btn-outline-primary" @click="viewDocument(doc)">
                    <i class="bi bi-eye"></i> View
                  </button>
                  <button class="btn btn-outline-success" @click="downloadDocument(doc)">
                    <i class="bi bi-download"></i> Download
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <StemErrorModal ref="stemErrorModal" />
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/components/BaseLayout.vue';
import StemErrorModal from '@/components/StemErrorModal.vue';
import CourseDocumentController from '@/controllers/CourseDocumentController';
import Subtask from '@/models/subtask';

export default {
  name: 'StudentCourseMaterialsView',
  components: {
    BaseLayout,
    StemErrorModal,
  },
  data() {
    return {
      courseDocuments: [],
      loading: true,
    };
  },
  async created() {
    await this.fetchDocuments();
  },
  methods: {
    async fetchDocuments() {
      this.loading = true;
      try {
        this.courseDocuments = await CourseDocumentController.fetchAvailableCourseDocuments();
      } catch (error) {
        this.$refs.stemErrorModal.show('Error', error.message);
      } finally {
        this.loading = false;
      }
    },
    async viewDocument(doc) {
      try {
        const response = await CourseDocumentController.downloadAvailableCourseDocument(doc.id);
        window.open(URL.createObjectURL(new Blob([response.data])));
      } catch (error) {
        this.$refs.stemErrorModal.show('Error', error.message);
      }
    },
    async downloadDocument(doc) {
      try {
        const response = await CourseDocumentController.downloadAvailableCourseDocument(doc.id);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', doc.file_name);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        this.$refs.stemErrorModal.show('Error', error.message);
      }
    },
    formatFileSize(bytes) {
      return Subtask.formatFileSize(bytes);
    },
    formatDate(date) {
      return Subtask.formatDateTimeZone(date);
    },
  },
};
</script>
